// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/radio-operating-procedure.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/radio-operating-procedure/radio-operating-procedure.js';

mount([g0]);
